import React from 'react';
import clsx from 'clsx';

import Divider from '@material-ui/core/Divider';
import makeStyles from '@material-ui/core/styles/makeStyles';

import Hero from '../components/Hero';
import WhatsSaga from '../components/WhatsSaga';
import Areas from '../components/Areas';
import OtherPlans from '../components/OtherPlans';
import Accesses from '../components/Accesses';
import Partners from '../components/Partners';
import Case from './Case';
import Report from './Report';
import { BACKGROUND_COLOR, DIVIDER_COLOR } from '../constants';
import AppLayout from '../../../front/Layout/AppLayout';
import type { SagaProps } from '../index';

const useStyles = makeStyles((theme) => ({
  heroContainer: {
    padding: theme.spacing(4, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6.25),
      position: 'relative',
      '&:after': {
        position: 'absolute',
        width: '100%',
        background: '#FDF9EA',
        height: '35%',
        bottom: '0',
        right: '0',
        content: "''",
        zIndex: '-1',
      },
    },
  },
  sectionsContainer: {
    padding: theme.spacing(4, 2),
    backgroundColor: BACKGROUND_COLOR,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6.25),
    },
  },
  accessContainer: {
    padding: `90px ${theme.spacing(2)}px`,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6.25, 2),
    },
  },
  divider: {
    backgroundColor: DIVIDER_COLOR,
    height: 1,
    margin: theme.spacing(9, 0),
  },
  dividerOnlySp: {
    [theme.breakpoints.up('sm')]: {
      backgroundColor: 'transparent',
    },
  },
  sectionWrapper: {
    paddingTop: theme.spacing(7),
  },
}));

const SagaComponent = ({
  plans = [],
  businesses = [],
  authenticated,
  ...headerProps
}: SagaProps) => {
  const classes = useStyles();
  return (
    <AppLayout {...headerProps} authenticated={authenticated}>
      <div className={classes.heroContainer}>
        <Hero />
      </div>
      <div className={classes.sectionsContainer}>
        <WhatsSaga />
        <Divider className={clsx(classes.divider, classes.dividerOnlySp)} />
        <Areas />
        <div className={classes.sectionWrapper}>
          <Report />
        </div>
        <Case />
        <div className={classes.sectionWrapper}>
          <OtherPlans
            plans={plans}
            businesses={businesses}
            isAuthenticated={authenticated}
          />
        </div>
      </div>
      <div className={classes.accessContainer}>
        <Accesses />
        <Partners />
      </div>
    </AppLayout>
  );
};

export default SagaComponent;
